import "es6-shim";
import * as React from 'react';
import RegionCodeValidator from '../../../services/Validator/RegionCode/RegionCodeValidator';
import '../../../styles/Form.css';
import '../Overview.css';
import { ILabelSelect, IGenericsLang } from "../../../services/Language/Types";
import { AddressCheckin } from "../../../dtos/KioskDtos.dtos";
import PatientDefault from "../../../services/Initializer/PatientDefaultInitializer";
import { IsArrayNullOrUndefinedOrEmpty } from "../../../utilities/Commons";
import { AddressEdit } from "./AddressEdit";
import { useMutateArrayState } from "../../../hooks/useMutateArrayState.hook";
import { PatientContactInfoEditFooter } from "./PatientContactInfoEditFooter";
import { useScrollEffectWhenMounted } from "../../../hooks/useScrollEffectWhenMounted.hook";

interface IAddressesEditContainerProp {
    lang: string;
    countryMappedStrings: any;
    stateList: any;
    countryList: ILabelSelect[];
    addresses: AddressCheckin[];
    contactPointOptions: ILabelSelect[];
    text: IGenericsLang;
    focusedInputName: string;
    defaultCountryAndState: { country: string, region: string };
    saveAddresses: (emails: AddressCheckin[]) => void;
    cancel: () => void;
    onFocus: (pipe: (value: any) => void, value: any, mask: string, id: string) => void;
    disconnectKeyboard(): void;
}

export const AddressesEditContainer = (props: IAddressesEditContainerProp) => {
    const [addresses, setAddresses] = useMutateArrayState<AddressCheckin>(props.addresses);

    const listContainer = useScrollEffectWhenMounted([addresses.length])

    const onAddressUpdate = (address: AddressCheckin, index: number) => setAddresses(addressState => {
        if (address.isPreferred && addressState.firstOrDefault(x => x.isPreferred) !== null) {
            addressState.forEach((x, i) => index !== i ? x.isPreferred = false : null);
            address.isPreferred = true;
        };
        addressState[index] = address;
    });

    const onDeleteAddress = (index: number) => setAddresses(addressesState => {
        const elementToRemove = addressesState[index];
        addressesState.splice(index, 1);
        if (elementToRemove.isPreferred && !addressesState.isEmpty()) {
            addressesState[0].isPreferred = true;
        };
    });

    const onAddressAdd = () => setAddresses(addressesState => {
        const { country, region } = props.defaultCountryAndState;
        const newAddress = PatientDefault.newAddress(country, region);
        if (addressesState.isEmpty()) {
            newAddress.isPreferred = true;
        }
        addressesState.push(newAddress);
    });

    const isFormValid = () => {
        if (!IsArrayNullOrUndefinedOrEmpty(addresses)) {
            if (addresses.some(addr =>
                !addr.city.trim() ||
                !addr.streetAddress.trim() ||
                !addr.country.trim() ||
                !addr.state.trim() ||
                !RegionCodeValidator.validateRegionCodeByCountry(addr.country, addr.zipCode)
            )) {
                return false;
            }
        }
        return true;
    };

    return (
        <div>
            <div className="col-sm-12 contact-info-edit-container" ref={listContainer}>
                {addresses.map((address, index) => (
                    <div className="row" key={"address-edit-" + index}>
                        <AddressEdit
                            countryList={props.countryList}
                            lang={props.lang}
                            countryMappedStrings={props.countryMappedStrings}
                            stateList={props.stateList}
                            address={address}
                            contactPointOptions={props.contactPointOptions}
                            index={index}
                            text={props.text}
                            focusedInputName={props.focusedInputName}
                            onDeleteAddress={() => onDeleteAddress(index)}
                            onAddressEdit={editedEmail => onAddressUpdate(editedEmail, index)}
                            onFocus={props.onFocus}
                            disconnectKeyboard={props.disconnectKeyboard}
                        />
                    </div>
                ))}
            </div>
            <PatientContactInfoEditFooter
                text={props.text.labels}
                addElementTextLabel={props.text.labels.AddAddressLabel}
                isFormValid={isFormValid()}
                onAddElementClick={onAddressAdd}
                onCancelClick={props.cancel}
                onSaveElementsClick={() => props.saveAddresses(addresses)}
            />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/AddressesEditContainer.tsx